export default function ({ route, redirect }) {
  // await store.dispatch('globals/getMarketList') // TODO: ?
  if (!route.name) redirect('/not-found')
}
